module.exports = __webpack_public_path__ + "img/Logo With EHR & Moto - No BG- Negative.d270feda.png";